/* src/app/core/layout/header/header.component.scss */
.appHeader {
  display: flex;
  align-items: center;
  height: 3.5rem;
  padding: 0 1.5rem 0 calc(4.5rem + 1.25rem);
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  font-size: 0.89rem;
  z-index: 1030;
}
.appHeader .navbar-brand {
  font-weight: 700;
  color: #2c3e50;
  letter-spacing: 0.01em;
}
.appHeader .strapline {
  margin-left: 0.6rem;
  padding-left: 0.6rem;
  border-left: 1px solid #e2e8f0;
  color: #94a3b8;
  font-size: 0.75rem;
}
.appHeader .navbar-collapse {
  align-items: center;
}
.breadcrumbNav {
  margin-left: 1.25rem;
}
.breadcrumb {
  background: transparent;
  padding: 0;
  margin: 0;
}
.breadcrumb .breadcrumb-item {
  font-size: 0.78rem;
  color: #94a3b8;
}
.breadcrumb .breadcrumb-item a {
  color: #64748b;
  text-decoration: none;
  transition: color 0.2s ease;
}
.breadcrumb .breadcrumb-item a:hover {
  color: #e07f0e;
}
.breadcrumb .breadcrumb-item.active {
  color: #1e293b;
  font-weight: 600;
}
.breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  color: #cbd5e1;
}
.headerActions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.alertContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  color: #64748b;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.alertContainer:hover {
  background: rgba(249, 148, 32, 0.12);
  color: #e07f0e;
}
.userMenuToggle {
  display: flex !important;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0.75rem 0.3rem 0.3rem !important;
  border-radius: 999px;
  transition: background-color 0.2s ease;
}
.userMenuToggle:hover {
  background: #f1f5f9;
}
.userMenuToggle .avatar {
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
}
.userMenuToggle span {
  font-weight: 500;
  color: #334155;
}
.dropdown-menu {
  border: none;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.14);
  border-radius: 0.6rem;
  padding: 0.4rem;
  margin-top: 0.5rem;
}
.dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.4rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.85rem;
}
.dropdown-menu .dropdown-item:hover {
  background: rgba(249, 148, 32, 0.1);
  color: #e07f0e;
}
/*# sourceMappingURL=header.component.css.map */
